import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiClock, FiAward, FiUsers, FiTool, FiHeart } = FiIcons;

const WhyChooseUs = () => {
  const features = [
    {
      icon: FiShield,
      title: 'Trusted & Reliable',
      description: 'Over 13 years of proven expertise with 500+ successful projects and zero compromise on quality.',
      color: 'text-blue-400'
    },
    {
      icon: FiClock,
      title: '24/7 Support',
      description: 'Round-the-clock customer support and emergency services whenever you need assistance.',
      color: 'text-green-400'
    },
    {
      icon: FiAward,
      title: 'Certified Professionals',
      description: 'Our team consists of licensed electricians and certified technicians with extensive training.',
      color: 'text-yellow-400'
    },
    {
      icon: FiUsers,
      title: 'Customer First',
      description: '200+ satisfied customers who trust us for their electrical and automation needs.',
      color: 'text-purple-400'
    },
    {
      icon: FiTool,
      title: 'Latest Technology',
      description: 'We use cutting-edge tools and modern techniques to deliver superior results.',
      color: 'text-cyan-400'
    },
    {
      icon: FiHeart,
      title: 'Local Expertise',
      description: 'Deep understanding of local requirements in Fatehgarh, Baramulla, and Kashmir region.',
      color: 'text-red-400'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="gradient-text">Why Choose Us?</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            We're not just service providers - we're your partners in creating safer, smarter, and more efficient electrical solutions.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group relative bg-gradient-to-br from-gray-800/30 to-gray-900/30 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/30 hover:border-blue-500/50 transition-all duration-500"
            >
              {/* Icon */}
              <div className="mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600/20 to-cyan-600/20 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 glow-blue">
                  <SafeIcon 
                    icon={feature.icon} 
                    className={`text-2xl ${feature.color}`} 
                  />
                </div>
              </div>

              {/* Content */}
              <div>
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-blue-300 transition-colors duration-300">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {feature.description}
                </p>
              </div>

              {/* Hover Effect */}
              <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-600/5 to-cyan-600/5" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;